import React from "react";

import "./Branches.css";

import Container from "../Container";

import Branch from "./Branch";



const Branches = () => {

  return (

    <Container>

      <section className="branches">

        <div className="branches-title">

          <div className="b-title">Sucursales</div>

          <div className="b-description">

            SUCURSALES A SU DISPOSICIÓN EN TODO EL PAÍS

          </div>

        </div>

        <div className="branches-items">

          <Branch

            location="CENTRAL"

            descriptions={[

              "Terminal de buses Tracopa, 50 m norte"

            ]}

            mapsLink="https://maps.app.goo.gl/L2ssHqjUNb2zoyQ67?g_st=aw"

            wazeLink="https://waze.com/ul/hd1u0qz0e3"

          />

          <Branch

            location="CARTAGO"

            descriptions={[

              "Frente a la Estación de Bomberos"

            ]}

            mapsLink="https://maps.app.goo.gl/QxG6w35DVovikBFr9"

            wazeLink="https://waze.com/ul/hd1u247bwu"

          />

          <Branch

            location="ALAJUELA"

            descriptions={[

              "75 m sur de los semáforos de la Corte"

            ]}

            mapsLink="https://maps.app.goo.gl/v1q4DhYCeS4hbzJe7"

            wazeLink="https://waze.com/ul/hd1u158h25"

          />

          <Branch

            location="GUADALUPE"

            descriptions={[

              "75 m oeste del Parque de Guadalupe, frente a la Chicharronera Goicoechea"

            ]}

            mapsLink="https://maps.app.goo.gl/r8gcMThBcjQm311G7"

            wazeLink="https://waze.com/ul/hd1u0x6d40"

          />

          <Branch

            location="SAN RAMON"

            descriptions={[

              "50 m este de Tiendas Ekono, frente a Carnes D'Feria"

            ]}

            mapsLink="https://maps.app.goo.gl/6sqne8zctDrXMHvE7?g_st=ipc"

            wazeLink=""

          />

          <Branch

            location="EL ROBLE"

            descriptions={[

              "El Roble, frente al Banco de Costa Rica"

            ]}

            mapsLink="https://maps.app.goo.gl/rzcFaFjigTdmzKaeA"

            wazeLink="https://waze.com/ul/hd1g8zbdrz"

          />

          <Branch

            location="CAÑAS"

            descriptions={[

              "Contiguo al Banco Nacional"

            ]}

            mapsLink="https://maps.app.goo.gl/YGJwaYcvYuo9p1MZ8"

            wazeLink="https://ul.waze.com/ul?place=ChIJUQLdDRb7n48RJt_Ih61KNrk&ll=10.42695560%2C-85.09126830&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

          />

          <Branch

            location="TRES RIOS"

            descriptions={[

              "50 m este del Más x Menos, edificio Sabino Guzmán, frente a Plaza Estación"

            ]}

            mapsLink="https://maps.app.goo.gl/snxLcuiVD6LjVmMaA"

            wazeLink="https://waze.com/ul/hd1u22gc9y"

          />

          <Branch

            location="LIBERIA"

            descriptions={[

              "75 metros Oeste de Correos de Costa Rica, frente a Ferretería San Carlos"

            ]}

            mapsLink="https://maps.app.goo.gl/8Ea1KMaSgdMzcMbe9"

            wazeLink=""

          />

          <Branch

            location="HEREDIA"

            descriptions={[

              "Banco Popular del Liceo de Heredia, 75 m este"

            ]}

            mapsLink="https://maps.app.goo.gl/A4py8Zf1Aew1T22i9"

            wazeLink="https://waze.com/ul/hd1u0vujwn"

          />

          <Branch

            location="GUAPILES"

            descriptions={[

              "Plaza Comercial Guápiles, contiguo a Subway"

            ]}

            mapsLink="https://maps.app.goo.gl/4WNDe1Z3Dx2zVi978"

            wazeLink="https://ul.waze.com/ul?preview_venue_id=181010534.1810170878.19879810&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

          />

          <Branch

            location="NICOYA"

            descriptions={[

              "300 m norte del Hospital La Anexión, diagonal a Ekono, frente a Colono Agropecuario"

            ]}

            mapsLink="https://maps.app.goo.gl/QH7YaXtykoSpyifc9"

            wazeLink="https://waze.com/ul/hd1g1z80rd"

          />

          <Branch

            location="SAN CARLOS"

            descriptions={[

              "Barrio San Roque, frente a la parroquia, plaza comercial contiguo a Yamaha"

            ]}

            mapsLink="https://maps.app.goo.gl/ywGTNXK9CswKmeSv6"

            wazeLink="https://waze.com/ul/hd1gfy8qc2"

          />

          <Branch

            location="SAN JOSÉ AV8"

            descriptions={[

              "Del Diario Extra 200 metros al Sur y 25 metros Este sobre Av8"

            ]}

            mapsLink="https://maps.app.goo.gl/CS7ctqsouabyYnkN8"

            wazeLink="https://ul.waze.com/ul?place=ChIJo6qagl3joI8Rdgv6XSvqYeE"

          />

          <Branch

            location="ESCAZÚ"

            descriptions={[

              "Parque de Escazú, 100 m norte, edificio esquinero contiguo a POPS"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Escazu+Costa+Rica"

            wazeLink="https://waze.com/ul/hd1u0mq47r"

          />

          <Branch

            location="DESAMPARADOS"

            descriptions={[

              "150 mts al Este de la Municipalidad, contiguo a ExtremeTech"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Desamparados+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Desamparados"

          />

          <Branch

            location="MALL PASEO DE LAS FLORES"

            descriptions={[

              "Segundo piso - III Etapa, en el mismo nivel de la entrada del Fortin"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Paseo+de+las+Flores+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Paseo%20de%20las%20Flores"

          />

          <Branch

            location="GRECIA"

            descriptions={[

              "Costado del parque, contiguo a Taquería Los Pira"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Grecia+Costa+Rica"

            wazeLink=""

          />

          <Branch

            location="PÉREZ ZELEDÓN"

            descriptions={[

              "50 m oeste de la Casa de la Juventud, esquina Clínica San Lucas"

            ]}

            mapsLink="https://maps.app.goo.gl/ugq6WM3yviR2mhWM7"

            wazeLink="https://waze.com/ul/hd1smr3ber"

          />

        </div>

        <div className="schedule">

          Lunes a Sábado: 9:00 am a 6:00 pm Domingo: CERRADO

        </div>

      </section>

    </Container>

  );

};



export default Branches;


